// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import api from "./api";
// import 'element-ui/lib/theme-chalk/index.css'
import {
  Button,
  Message,
  MessageBox,
  Pagination,
  Loading,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Tag,
  Empty,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Image,
  Row,
  Col
} from "element-ui";

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
Vue.prototype.$api = api;

Vue.use(Button);
Vue.use(Pagination);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Tag);
Vue.use(Empty);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Image);
Vue.use(Row);
Vue.use(Col);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js